import React, { useState, useEffect } from 'react';




function Distribution() {
  const [heading, setHeading] = useState('');
  const [material, setMaterial] = useState('');
  const [Class, setClass] = useState('');
  const [quantity, setQuantity] = useState('');
  const [peritem, setPerItem] = useState('');
  const [teacherName, setteacheraname] = useState('');
  const [provider, setprovider] = useState('');
  const [tamount, setTamount] = useState('');
  const [date, setDate] = useState('');
  const [remark, setRemark] = useState('');
  const [headings, setHeadings] = useState([]);
  const [newHeading, setNewHeading] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({});
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [editingKey, setEditingKey] = useState(null);
  const [filteredData, setFilteredData] = useState({});
  const [schoolName, setSchoolName] = useState("");
  const [taluka, setTaluka] = useState("");
  const [selectedClass, setSelectedClass] = useState('');
  const [jilha, setJilha] = useState("");
  const [logoURL, setLogoURL] = useState(null);
  const language =localStorage.getItem("language") || "English";
 
  const renderTableForHeading = (heading, index) => {
    if (!data || typeof data !== 'object') {
      return null; // Return null if data is not an object
    }
  
    const filteredData = Object.keys(data)
      .filter(key => data[key] && data[key].Heading === heading && key !== "0")
      .filter(key => {
        const item = data[key];
        return item && (
          item.Material ||
          item.Class ||
          item.teacherName ||
          item.provider ||
          item.Quantity ||
          item.PerItemAmount ||
          item.TotalAmount ||
          item.date ||
          item.Remark
        );
      });
  
    if (filteredData.length > 0) {
      return (
        <div key={index}>
          <label style={{ marginLeft: "5px", marginTop: '10px' }}>
            {language === "English" ? "Category: " : "कॅटेगरी:"} {heading}
          </label>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '30px',
            fontFamily: 'Arial, sans-serif',
            border: '1px solid black',
            borderRadius: '10px',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          }}>
            <thead>
              <tr>
                {['Sr. No.', 'Material', 'Class', 'Teacher', 'Provider', 'Quantity', 'Per Item Amount', 'Total Amount', 'Date', 'Remark', 'Action'].map((header, idx) => (
                  <th key={idx} style={{ fontWeight: 'bold', border: '1px solid black', padding: '6px 4px', textAlign: "center" }}>
                    {language === "English" ? header : translateHeader(header)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((key, index) => (
                <tr key={index}>
                  <td className='firthtd' style={{ border: '1px solid black', padding: '6px 4px' }}>{index + 1}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Material}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Class}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.teacherName}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.provider}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Quantity}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{parseFloat(data[key]?.PerItemAmount).toFixed(1)}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{parseFloat(data[key]?.TotalAmount).toFixed(1)}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{formatDate(data[key]?.date)}</td>
                  <td style={{ border: '1px solid black', padding: '6px' }}>{data[key]?.Remark}</td>
                  <td style={{ border: '1px solid black', width: '80px' }}>
                    <div style={{ display: 'flex' }}>
                      <button style={{ padding: '5px', fontSize: '18px', border: 'none', backgroundColor: 'transparent', color: '#8A1538', marginRight: '10px' }} onClick={() => handleEdit(key)}>
                        <i className="fa-solid fa-pen-to-square"></i>
                      </button>
                      <button style={{ padding: '5px', fontSize: '18px', border: 'none', color: 'red', backgroundColor: 'transparent' }} onClick={() => handleDelete(key)}>
                        <i className="fa-regular fa-trash-can"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return null; // Return null if there's no data for this heading
  };
  
  const translateHeader = (header) => {
    const translations = {
      'Sr. No.': 'अ.क्र.',
      'Material': 'साहित्य',
      'Class': 'वर्ग',
      'Teacher': 'शिक्षक',
      'Provider': 'पुरवणारा',
      'Quantity': 'प्रमाण',
      'Per Item Amount': 'रक्कम',
      'Total Amount': 'एकूण रक्कम',
      'Date': 'तारीख',
      'Remark': 'टिप्पणी',
      'Action': 'कृती'
    };
    return translations[header] || header;
  };
  

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0]; // Format to yyyy-MM-dd
    setDate(formattedDate);
  }, []);

  useEffect(() => {
    if (quantity && peritem) {
      const total = parseFloat(quantity) * parseFloat(peritem);
      setTamount(total);
    }
  }, [quantity, peritem]);
  
  
  const handleQuantityChange = (event) => {
    const value = event.target.value;
    setQuantity(value);

    // Calculate total amount only if peritem is set
    if (peritem) {
      const total = parseFloat(value) * parseFloat(peritem);
      setTamount(total);
    }
  };

  const handlePerItemChange = (event) => {
    const value = event.target.value;
    setPerItem(value);

    // Calculate total amount only if quantity is set
    if (quantity) {
      const total = parseFloat(quantity) * parseFloat(value);
      setTamount(total);
    }
  };
  const addNewHeading = () => {
    if (newHeading.trim() !== "") {
    setHeadings(prevHeadings => [...prevHeadings, newHeading]);
    setHeading(newHeading); // Set the selected heading to the new heading
    setShowPopup(false);
  }
  };

  const romanToInt = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };
  
  const marathiToInt = {
    'पहिली': 1,
    'दुसरी': 2,
    'तिसरी': 3,
    'चौथी': 4,
    'पाचवी': 5,
    'सहावी': 6,
    'सातवी': 7,
    'आठवी': 8,
    'नववी': 9,
    'दहावी': 10,
    'अकरावी':11,
    'बारावी': 12
  };

  const [classOptions, setClassOptions] = useState([]);

  useEffect(() => {
    const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
    const classOptionsArray = romanNumerals.map((numeral, index) => `Class ${numeral}`);
    
    const fetchClassDiv = async () => {
      try {
        const classDiv = localStorage.getItem("classDiv");
        
        if (classDiv) {
          const classData = JSON.parse(classDiv);
          const classOptions = Object.keys(classData);
          const combinedClassOptions = [...classOptionsArray, ...classOptions];
          const uniqueClassOptions = [...new Set(combinedClassOptions)];
          const filteredClassOptions = uniqueClassOptions.map(option => {
              return option;
          });
          setClassOptions(filteredClassOptions);
        } else {
          setClassOptions(classOptionsArray);
        }
      } catch (error) {
        console.error('Error fetching class data:', error);
        setClassOptions(classOptionsArray);
      }
    };
    
    fetchClassDiv();
  }, [udiseNumber]);
  


  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };


  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0'); 
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/SchoolDistribution.json`;
      try {
        const response = await fetch(url, {
          method: 'GET',
        });
        const data = await response.json();
        setData(data); // Store the full data
  
        // Extract unique headings from SchoolDistribution
        if (data) {
          const headingsFromDistribution = Object.values(data)
            .filter((item) => item && item.Heading) // Ensure item is not null and has a Heading property
            .map((item) => item.Heading);
          const uniqueHeadings = [...new Set(headingsFromDistribution)];
          setHeadings(uniqueHeadings); // Set the unique headings
        }
  
        // Filter data based on the selected heading
        if (heading && data) {
          const filtered = Object.keys(data).reduce((acc, key) => {
            if (data[key] && data[key].Heading === heading) {
              acc[key] = data[key];
            }
            return acc;
          }, {});
          setFilteredData(filtered);
        } else {
          setFilteredData(data || {}); // If no heading is selected, show all data (or an empty object if data is null)
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [udiseNumber]); 


  const handlesave = async (event) => {
    event.preventDefault();
    if (!date || !material) {
      alert("Date and Material Please fill them in.");
      return;
    }
    setSaving(true);
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/SchoolDistribution.json`;
  

    try {
      const response = await fetch(url, {
        method: 'GET',
      });

      const data = await response.json();

      if (data) {
        const updatedData = { ...data };

        if (editingKey) { // Check if we are editing existing data
          updatedData[editingKey] = {
            Class: selectedClass,
            date: date,
            Heading: heading,
            Material: material,
            PerItemAmount: peritem,
            Quantity: quantity,
            Remark: remark,
            teacherName:teacherName,
            provider:provider,
            TotalAmount: tamount,
          };
        } else {
          const maxnumber = Math.max(...Object.keys(data).map(Number)) || 0;
          const newId = maxnumber + 1;

          updatedData[newId] = {
            Class: selectedClass,
            date: date,
            Heading: heading,
            Material: material,
            PerItemAmount: peritem,
            Quantity: quantity,
            Remark: remark,
            teacherName:teacherName,
            provider:provider,
            TotalAmount: tamount,
          };
        }

        const updateResponse = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        });

        if (updateResponse.ok) {
          setSaving(false);
          // You can also reset the form fields here
          setHeading('');
          setMaterial('');
          setClass('');
          setteacheraname('');
          setQuantity('');
          setPerItem('');
          setTamount('');
          setRemark('');
          setprovider('')
          setEditingKey(null); // Reset the editing key
          const response = await fetch(url, {
            method: 'GET',
          });
          const data = await response.json();
          setData(data);
        } else {
          console.error('Error saving data:', updateResponse.statusText);
          setSaving(false);
        }
      } else {
        const newId = 1;
        const newData = {
          [newId]: {
            Class: selectedClass,
            date: date,
            Heading: heading,
            Material: material,
            PerItemAmount: peritem,
            Quantity: quantity,
            Remark: remark,
            teacherName:teacherName,
            provider:provider,
            TotalAmount: tamount,
          },
        };

        const updateResponse = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newData),
        });

        if (updateResponse.ok) {
          setSaving(false);
          
          setHeading('');
          setMaterial('');
          setClass('');
          setQuantity('');
          setteacheraname('');
          setPerItem('');
          setTamount('');
          setDate('');
          setRemark('');
          setprovider('');
          setEditingKey(null); // Reset the editing key
          const response = await fetch(url, {
            method: 'GET',
          });
          const data = await response.json();
          setData(data);
        } else {
          console.error('Error saving data:', updateResponse.statusText);
          setSaving(false);
        }
      }
    } catch (error) {
      console.error('Error saving data:', error);
      setSaving(false);
    }
  };

  const handleEdit = (key) => {
    const selectedData = data[key];
    setHeading(selectedData.Heading);
    setMaterial(selectedData.Material);
    setClass(selectedData.Class);
    setQuantity(selectedData.Quantity);
    setPerItem(selectedData.PerItemAmount);
    setTamount(selectedData.TotalAmount);
    setDate(selectedData.date);
    setRemark(selectedData.Remark);
    setteacheraname(selectedData.teacherName);
    setprovider(selectedData.provider);
    setEditingKey(key); // Add this line to store the key of the data being edited
  };

  const handleDelete = async (key) => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/SchoolDistribution.json`;
 

    try {
      const response = await fetch(url, {
        method: 'GET',
      });

      const data = await response.json();

      if (data) {
        const updatedData = { ...data };
        delete updatedData[key];

        const updateResponse = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        });

        if (updateResponse.ok) {
          const response = await fetch(url, {
            method: 'GET',
          });
          const data = await response.json();
          setData(data);
        } else {
          console.error('Error deleting data:', updateResponse.statusText);
        }
      } else {
        console.error('No data found');
      }
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };
  
  

const handlePrint = () => {
  const printContent = document.querySelector('.modal-content');

  if (printContent) {
    const cloneContent = printContent.cloneNode(true);

    const otherDetails = cloneContent.querySelectorAll('p'); 
    otherDetails.forEach((p, index) => {
      if (index !== 0) { 
        p.style.fontWeight = 'normal'; 
      }
    });
    removeLastColumnOnPrint(cloneContent);

    const printWindow = window.open('', '', 'height=800,width=600');
    printWindow.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: A4 Potrait;
              margin: 5mm;
              padding: 15px;
              border: 1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              font-size: 16px;
            }
            th, td {
              border: 1px solid black;
              text-align: center;
              padding: 5px;
            }
            td {
              font-size: 16px;
            }
            th {
              background-color:  rgb(166 214 245);
            }
            .print-button {
              display: none;
            }
            .school-header-container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .school-header2 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 0 0 auto; /* Prevent this section from growing */
              margin-right: 10px;
            }
            .school-header2 img {
              max-height: 70px;
            }
            .school-header {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center; margin-left:-70px;
              flex: 1 1 auto; /* This makes the school header take available space */
            }
            .school-header h1 {
              font-size: 28px;
              margin: 5px 0;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .school-header .report-title {
              font-size: 20px;
              margin: 5px auto;
              font-weight: bold;
              border: 1px solid black;
              width: 200px;
              padding: 5px;
              text-align: center;
              border-radius: 10px;
              background-color: black;
              color: white;
            }
            .school-header .report-tit {
              font-size: 16px;
              margin: 5px auto;
              font-weight: bold;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="school-header-container">
            <div class="school-header2">
              ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
            </div>
            <div class="school-header">
              <div style="margin-left: 15px;">
                <h1>${schoolName}</h1>
                <div class="report-tit">
                  ${language === 'English' ? 'Taluka' : 'तालुका'} ${taluka}, ${language === 'English' ? 'District' : 'जिल्हा'} : ${jilha}
                </div>
                <div class="report-title">
                  ${language === "English" ?  "School Supply Report" : "शालेय साहित्य अहवाल"}
                </div>
              </div>
            </div>
          </div>
          <style>
            .styled-table {
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
          </style>
          ${cloneContent.outerHTML}
        </body>
      </html>
`);
    printWindow.document.close(); 

    appendLastColumnOnPrint(cloneContent);
    printWindow.focus(); // Focus the new window
    printWindow.print(); // Trigger print
    printWindow.close(); // Close the print window after printing
  } else {
    console.error('Print content not found');
  }
};

function removeLastColumnOnPrint(cloneContent) {
  const tables = cloneContent.querySelectorAll('table'); // Get all tables in the cloned content
  tables.forEach(table => {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = 'none'; // Hide last column header
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = 'none'; // Hide last column data
      }
    });
  });
}


function appendLastColumnOnPrint(cloneContent) {
  const table = cloneContent.querySelector('table'); // Use the cloned content to find the table
  if (table) {
    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');

    const lastHeader = thead.querySelector('tr th:last-child');
    if (lastHeader) {
      lastHeader.style.display = '';
    }

    tbody.querySelectorAll('tr').forEach(row => {
      const lastCell = row.querySelector('td:last-child');
      if (lastCell) {
        lastCell.style.display = '';
      }
    });
  } else {
    console.error('Table not found in the cloned content');
  }
}
  const uniqueHeadings = data ? [...new Set(Object.values(data).map((item) => item?.Heading))] : [];


  const fetchSchoolName = async () => {
    if (udiseNumber) {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`);
        const schoolData = await response.json();
        if (schoolData) {
          if (schoolData.schoolName) {
            setSchoolName(schoolData.schoolName);
          }
          if (schoolData.taluka) {
            setTaluka(schoolData.taluka);
          }
          if (schoolData.jilha) {
            setJilha(schoolData.jilha);
          }
          if (schoolData.schoolLogo) {
            setLogoURL(schoolData.schoolLogo);
          }
        }
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };
  useEffect(() => {
  fetchSchoolName();
}, [udiseNumber]);

const handleHeadingChange = (event)=>{
  const selectedValue = event.target.value;
    if (selectedValue === "add-new-heading") {
      setShowPopup(true);
    } else {
      setHeading(selectedValue); 
      setShowPopup(false);
      
}
}

  return (
    <div className='main-content-of-page' style={{ padding: '20px' }}>
      <div style={{ border: '1px solid #ccc', width: '60%', margin: 'auto', marginTop: '10px', padding: '25px 30px ', borderRadius:'5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
            
<h3 style={{textAlign:'center',color:'#1B4332',fontWeight:'bold', marginBottom:'15px'}}>{language === "English" ? "School Supplies" : "शालेय साहित्य"}</h3>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
    
          
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Category:" : "कॅटेगरी:"}</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <select
  value={heading}
  // onChange={(event) => {
  //   const selectedValue = event.target.value;
  //   if (selectedValue === "add-new-heading") {
  //     setShowPopup(true); 
  //   } else {
  //     setHeading(selectedValue); 
  //   }
  // }}

  onChange={handleHeadingChange}
  style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
>
  <option value="">{language === "English" ? "Select Category" : "कॅटेगरी निवडा"}</option>
  {headings.map((heading, index) => (
    <option key={index} value={heading}>
      {heading}
    </option>
  ))}
  <option value="add-new-heading">{language === "English" ? "Add New Category" : "नवीन कॅटेगरी जोडा"}</option>
</select>

              {showPopup && (
                <div className="modal1">
                  <div className="modal-content minority-form">
                    <div
                      style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        zIndex: 1000,
                      }}
                    >
                      <button
                        style={{
                          position: 'absolute',
                          top: '-50px',
                          right: '-10px',
                          padding: '5px',
                          fontSize: '24px',
                          border: 'none',
                          backgroundColor: 'transparent',
                          color: 'red',
                        }}
                        onClick={() => setShowPopup(false)}
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </button>
                      <h6 className='text-center'>Add Category</h6>
                      <input
                        type="text"
                        value={newHeading}
                        onChange={(event) => setNewHeading(event.target.value)}
                        style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
                        autoFocus
                      />
                      <button
                        style={{
                          marginLeft: '10px',
                          padding: '4px 10px',
                          fontSize: '16px',
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          backgroundColor: 'Green',
                          color: 'White', float: 'right', marginTop: '10px'
                        }}
                        onClick={addNewHeading}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              )}

            </div>


          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Material" : "साहित्य"}</label>
            <input
              type='text'
              value={material}
              onChange={(event) => setMaterial(event.target.value)}
              placeholder='Enter Material'
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Class" : "वर्ग"}</label>
           
            <select id="classDropdown" value={selectedClass} onChange={handleClassChange} className="brown-dropdown dropdown" style={{ width: '100%', height:'35px'}}>
              <option value="">{language === "English" ? "Select" : "निवडा"}</option>
              

              {classOptions
  .filter(cls => cls !== null && cls !== undefined && cls !== '') // Filter out null and undefined classes
  .sort((a, b) => {
    const classA = a.split(' ')[1];
    const classB = b.split(' ')[1];
    let numA, numB;

    if (language === "English") {
      numA = romanToInt[classA] !== undefined ? romanToInt[classA] : 0; // Default to 0 if not found
      numB = romanToInt[classB] !== undefined ? romanToInt[classB] : 0; // Default to 0 if not found
    } else {
      numA = marathiToInt[classA] !== undefined ? marathiToInt[classA] : 0; // Default to 0 if not found
      numB = marathiToInt[classB] !== undefined ? marathiToInt[classB] : 0; // Default to 0 if not found
    }

    return numA - numB; // Sort based on the numerical value
  })
  .map((cls, index) => (
    <option key={index} value={cls}>
      {cls}
    </option>
  ))}
            </select>
          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Teacher" : "शिक्षक"}</label>
            <input
              type='text'
              value={teacherName}
              onChange={(event) => setteacheraname(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

       
          <div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Quantity" : "प्रमाण"}</label>
            <input
              type='text'
              value={quantity}
             onChange={handleQuantityChange}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Per Item Amount" : " रक्कम"}</label>
            <input
              type='number'
              value={peritem}
              onChange={handlePerItemChange}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Total Amount" : "एकूण रक्कम"}</label>
            <input
              type='number'
              value={tamount}
              onChange={(event) => setTamount(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
          <div style={{  marginRight: '15px',width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Provider" : "पुरवणारा"}</label>
            <input
              type='text'
              value={provider}
              onChange={(event) => setprovider(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Date" : "तारीख"}</label>
            <input
              type='date'
              value={date}
              onChange={(event) => setDate(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>

          <div style={{ marginRight: '15px', width: '20%' }}>
            <label style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px', width: '100%' }}>{language === "English" ? "Remark" : "टिप्पणी"}</label>
            <input
              type='text'
              value={remark}
              onChange={(event) => setRemark(event.target.value)}
              style={{ padding: '6px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}
            />
          </div>
        </div>
        <div style={{
          textAlign: 'center'
        }}>
          <button type="button" onClick={handlesave} style={buttonStyle}>
            {saving ? 'Saving...' : 'Save'}
          </button>

          <button type="button" onClick={handlePrint} style={buttonStyleReport}>
          {language === "English" ? "Print" : "प्रिंट "}
        </button>
    
        </div>
      </div>
      <div style={{
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '10px',
  width: '100%',
  maxWidth: '1200px',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.7)',
  maxHeight: '100%',
  position: 'relative', margin: '40px auto'
}}>

  <div className="modal-content p-3" style={{ border: '1px solid black' }}>
    <h5 className='h3classforschol' style={{ textAlign: 'center', color: '#1B4332', fontWeight: 'bold', marginBottom: '5px' }}>
      {language === "English" ? "School Supplies" : "शालेय साहित्य"}
    </h5>

    {heading ? (
      renderTableForHeading(heading)
    ) : (
      uniqueHeadings.map((heading, index) => renderTableForHeading(heading, index))
    )}
  </div>
</div>


</div>

  );
}

export default Distribution;

const buttonStyleReport= {
  marginTop: '20px',
  padding: '8px 16px',
  fontSize: '14px',
  backgroundColor: '#d4a017',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  marginLeft:'20px',
  right:'0',
  float:'right'
}
const buttonStyle = {
  marginTop: '20px',
  padding: '8px 20px',
  fontSize: '14px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};